import useSWR from "swr"
import {API_URL} from "../constants/apiUrls"

export default function useTeamLexiconId(teamId) {
    const {data, mutate, error} = useSWR(`${API_URL}/teams/${teamId}`)
    return {
        teamLexiconId: data && data.team_lexicon.id,
        mutateTeamLexiconId: mutate,
        isLoadingTeamLexiconId: !error && !data,
        isErrorTeamLexiconId: error
    }
}